/**
 * This is the Angular 18 way of getting access to the window.
 *
 * Admittedly, I do not understand shit of this!
 */
import {InjectionToken} from '@angular/core'

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW =
  new InjectionToken<Window>('window')

/**
 * The provider
 */
export const windowProvider = () => {
  return globalThis
}
